import { CURRENCIES, CURRENCY_SYMBOL, useCurrency } from '../lib/currency';
import { t } from '../lib/i18n';
import { cn } from '../lib/cn';

/**
 * Selector segmentado de moneda de visualización (₲ / R$ / US$).
 *
 * Mismo lenguaje visual que el toggle ES|PT del header. Colores 100% desde
 * tokens. Accesible: `role="group"` + `aria-pressed` en la opción activa.
 */
export function CurrencySelector({ className }: { className?: string }) {
  const { currency, setCurrency } = useCurrency();

  return (
    <div
      role="group"
      aria-label={t('currency.label')}
      className={cn(
        'inline-flex overflow-hidden rounded-token border border-line font-mono text-xs',
        className,
      )}
    >
      {CURRENCIES.map((c) => {
        const active = currency === c;
        return (
          <button
            key={c}
            type="button"
            aria-pressed={active}
            title={t(`currency.name.${c}`)}
            onClick={() => setCurrency(c)}
            className={cn(
              'px-2.5 py-1.5 transition-colors',
              active
                ? 'bg-brand text-brand-ink'
                : 'text-muted hover:text-ink',
            )}
          >
            {CURRENCY_SYMBOL[c]}
          </button>
        );
      })}
    </div>
  );
}
